module.exports = __webpack_public_path__ + "media/images/Rectangle-afd7e05a.png";